import { useEffect, useMemo } from 'react';
import * as _ from 'lodash-es';

import { isUrlExpired, parsePath, Target } from '/shared/FilePreview/helpers';
import type { SourceType, IHandlerProps } from '/shared/FilePreview/types';
import { ProcessPreview } from '/shared/FilePreview/ProcessPreview';

import { urlStorage } from '../urlStorage';

export function UrlHandler({ source, id, ...rest }: IHandlerProps<string>) {
  const urlID = useMemo(() => id || parsePath(source, Target.Hash), [source, id]);

  const url = useMemo(() => {
    if (!urlID) return undefined;
    const cached = urlStorage.get(urlID);
    return cached && !isUrlExpired(cached) ? cached : source;
  }, [urlID, source]);

  useEffect(() => {
    if (urlID && url === source) {
      urlStorage.set(urlID, source);
    }
  }, [urlID, source, url]);

  return <ProcessPreview url={url} {...rest} />;
}
UrlHandler.canProcess = (source: SourceType): boolean => _.isString(source);
